import React from 'react';
import LoginPageContentEditor from '../../components/LoginPageContentEditor';

/**
 * Site content admin page. Wraps the existing login-page footer / public
 * content editor so it lives on its own URL and can be deep-linked
 * (`/admin/site-content`) instead of being a tab inside the monolith.
 *
 * The editor itself is unchanged — it still writes to publicSiteContent
 * which is publicly readable per firestore.rules.
 */
export default function SiteContentAdmin() {
  return <LoginPageContentEditor />;
}
